/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const CustomPhone = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Custom Phone 24">
      <g className="Fill-Main">
        <path
          fill="#5E1FF0"
          d="M12 12.005h1.165v1.164H12v-1.164Zm1.915 2.744h.835v-.835h-.835v.835Zm0-4.658h.835v-.835h-.835v.835Zm-4.665 0h.835v-.835H9.25v.835Zm9.31 10.525v.125c-.07 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.335 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32v17.352h-.01ZM9 3.26c0 .414.335.75.75.75h4.5a.749.749 0 1 0 0-1.5h-4.5a.749.749 0 0 0-.75.75Zm.665 11.08H8.5v1.165h1.165V14.34Zm2.335 0h-1.165v1.165H12V14.34Zm3.5-1.17h-1.165v-1.164H13.17V10.84h-1.165v1.165H10.84v1.164h1.165v1.165h1.165v1.165h2.335v-2.335l-.005.005Zm0-2.329V8.506H12v1.16h-1.165v-1.16H8.5v2.334h1.165v1.165H8.5v1.164h1.165v1.165h1.165v-1.165H9.665v-1.164h1.165V10.84H12V9.666h1.165v1.174h1.17v1.17H15.5v-1.17Z"
        />
        <path
          fill="#fff"
          fillOpacity={0.8}
          d="M12 12.005h1.165v1.164H12v-1.164Zm1.915 2.744h.835v-.835h-.835v.835Zm0-4.658h.835v-.835h-.835v.835Zm-4.665 0h.835v-.835H9.25v.835Zm9.31 10.525v.125c-.07 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.335 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32v17.352h-.01ZM9 3.26c0 .414.335.75.75.75h4.5a.749.749 0 1 0 0-1.5h-4.5a.749.749 0 0 0-.75.75Zm.665 11.08H8.5v1.165h1.165V14.34Zm2.335 0h-1.165v1.165H12V14.34Zm3.5-1.17h-1.165v-1.164H13.17V10.84h-1.165v1.165H10.84v1.164h1.165v1.165h1.165v1.165h2.335v-2.335l-.005.005Zm0-2.329V8.506H12v1.16h-1.165v-1.16H8.5v2.334h1.165v1.165H8.5v1.164h1.165v1.165h1.165v-1.165H9.665v-1.164h1.165V10.84H12V9.666h1.165v1.174h1.17v1.17H15.5v-1.17Z"
        />
      </g>
      <path
        fill="#000"
        d="M16.33.02 16.06 0v.01H7.94V0l-.27.02C5.95.15 4.59 1.524 4.5 3.224v17.392C4.5 22.481 6.04 24 7.935 24h8.125c1.895 0 3.435-1.52 3.44-3.384V3.394c0-1.755-1.39-3.24-3.17-3.374Zm2.23 20.721c-.065 1.265-1.085 2.264-2.37 2.33H7.94c-1.335 0-2.43-1.02-2.495-2.33V3.394c0-1.28.975-2.334 2.27-2.45l8.355-.01v-.01l.23.02c1.235.11 2.21 1.11 2.27 2.32V20.74h-.01ZM9 3.26c0-.415.335-.75.75-.75h4.5a.749.749 0 1 1 0 1.5h-4.5A.749.749 0 0 1 9 3.26Zm.665 8.746v1.164h1.165v1.165H9.665V13.17H8.5v-1.164h1.165Zm4.665 0h-1.165V10.84H12v1.165h-1.165v1.164H12v1.165h1.165v1.165H15.5v-2.335h-1.165V12l-.005.005Zm-1.165 1.164H12v-1.164h1.165v1.164Zm1.585.75v.835h-.835v-.83h.835v-.005Zm-3.915.42H12v1.165h-1.165V14.34Zm4.665-3.798V8.506H12v1.16h-1.165v-1.16H8.5v2.335h1.165v1.164h1.165V10.84H12V9.667h1.165v1.175h1.17v1.169H15.5v-1.469Zm-5.415-.45H9.25v-.835h.835v.835Zm4.665 0h-.835v-.835h.835v.835ZM8.5 14.339h1.165v1.165H8.5v-1.165Z"
        className="Details"
      />
    </g>
  </svg>
);

export const CustomPhoneIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'custom-phone-icon'}
      icon={CustomPhone}
      {...props}
      size={size}
    />
  );
};
